module.exports = __webpack_public_path__ + "img/mb_banner12.4b265d95.png";